module.exports = __webpack_public_path__ + "img/20191218155336730.1bee07ce.jpg";